<section layout="row" [ngClass]="styles.wrapper" [hidden]="!statusInfo.isPendingApprovalStage">
	<span flex-align-self="center" class="margin-right-5 text-align-center">
		<span [ngClass]="styles.stepName">
			<span class="glyphicons circle_info">
			</span>
			{{ 'ApprovalWorkflow_ContentApproval' | translate }}
			{{ approvalDetails.numberStepsProcessed }}/{{ approvalDetails.numberOfSteps }} -
		</span>
		{{ 'ApprovalWorkflow_VideoPendingMessage' | translate }}
	</span>
	<button type="button" [hidden]="!showActionButtons" class="margin-right-5" vbUiBtnSecondaryNgx (click)="rejectVideo()">
		{{ 'Reject' | translate }}
	</button>
	<button type="button" [hidden]="!showActionButtons" class="margin-right-5" vbUiBtnPrimaryNgx (click)="approveVideo()">
		{{ 'Approve' | translate }}
	</button>
	<approval-submitted-details [hidden]="!isVideoUploader" [submittedDateTime]="approvalDetails.whenSubmitted">
	</approval-submitted-details>
</section>

<section layout="row" [ngClass]="styles.wrapper" [hidden]="!statusInfo.isApprovedApprovalStage">
	<span [ngClass]="styles.stepName">
		<span class="glyphicons circle_ok">
		</span>
		{{ 'VideoApproved' | translate }}
	</span>
</section>

<section layout="row" [hidden]="!(statusInfo.isRejectedApprovalStage && !isVideoUploader)" [ngClass]="styles.wrapper">
	<span flex-align-self="center" class="margin-right-5 text-align-center">
		<span [ngClass]="styles.stepName">
			<span class="glyphicons circle_remove">
			</span>
			{{ 'VideoRejected' | translate }} -
		</span>
		{{ 'ApprovalWorkflow_VideoRejectedMessage' | translate }}
	</span>
	<button type="button" class="margin-right-5" vbUiBtnSecondaryNgx (click)="deleteVideo()">
		{{ 'UI_DeleteVideo' | translate }}
	</button>
</section>